var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8871 0.115509C10.7954 0.018921 10.6697 -0.0390625 10.5394 -0.0390625H2.7374C1.29773 -0.0390625 0.109375 1.14456 0.109375 2.58408V17.3377C0.109375 18.7773 1.29773 19.961 2.7374 19.961H13.3267C14.7664 19.961 15.9547 18.7773 15.9547 17.3377V5.62272C15.9547 5.49714 15.8968 5.37644 15.8147 5.28459L10.8871 0.115509ZM11.0272 1.66626L14.3268 5.13001H12.1818C11.5442 5.13001 11.0272 4.61793 11.0272 3.98026V1.66626ZM13.3267 18.9948H2.7374C1.83408 18.9948 1.07556 18.246 1.07556 17.3377V2.58408C1.07556 1.68076 1.8292 0.927126 2.7374 0.927126H10.061V3.98026C10.061 5.15412 11.008 6.0962 12.1818 6.0962H14.9886V17.3377C14.9886 18.246 14.2349 18.9948 13.3267 18.9948Z",
    fill: "#696969"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.a5d704625dc129cb356f47d01c9b77bd.svg";
export { ForwardRef as ReactComponent };